import { render, staticRenderFns } from "./BranchesInsurance.vue?vue&type=template&id=ef6fce18&"
import script from "./BranchesInsurance.vue?vue&type=script&lang=js&"
export * from "./BranchesInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports